import { useQuery } from '@tanstack/react-query'
import { useAuthContext } from '../../hooks/useAuthContext'
import * as productApi from '../../api/shopify/product'

const useProduct = () => {
    const { user } = useAuthContext()

    const { isLoading: isLoadingProducts, isError: isErrorProducts, error: errorProducts, data: products } = useQuery({
        queryKey: ['products'],
        queryFn: async () => {
            const response = await productApi.getProducts(user.token)

            const json = await response.json()

            if (!response.ok) throw new Error(json.error)

            return json?.data?.products?.edges ?? null
        }
    })
    

    const { isLoading: isLoadingCollections, isError: isErrorCollections, error: errorCollections, data: collections } = useQuery({
        queryKey: ['collections'],
        queryFn: async () => {
            const response = await productApi.getCollections(user.token)

            const json = await response.json()

            if (!response.ok) throw new Error(json.error)

            return json.data?.collections?.edges ?? null
        }
    })

    return {
        isLoadingProducts,
        errorProducts,
        isErrorProducts,
        isLoadingCollections,
        isErrorCollections,
        errorCollections,
        products,
        collections
    }
}

export default useProduct

